export default __webpack_public_path__ + "static/media/T130MANC2.6db69bec.pdf";